













# import settings from '@/settings'
import Menus from '@/components/menus'
import company_form from '@/components/company_form'

export default {
    name: 'distributor_add_company'

    components: { Menus, company_form }

    # beforeMount: ()->
    #     console.log "ADD "
}
